const teamData = [
    {
      image: require("../../../Assets/Team/pravin2.jpg"),
      title: "Pravin Nikum",
      text: "President",
    },
    {
      image: require("../../../Assets/Team/tejas2.jpg"),
      title: "Teajs Thakur",
      text: "Vice-President",
    },
    {
      image: require("../../../Assets/Team/mayur.jpg"),
      title: "Mayur Koli",
      text: "Secretary",
    },
    {
      image: require("../../../Assets/Team/yashBaba.jpg"),
      title: "Yash Salave",
      text: "Vice-Secretary",
    },
    {
      image: require("../../../Assets/Team/Prasad.jpg"),
      title: "Prasad Wani",
      text: "Treasurer",
    },
    {
      image: require("../../../Assets/Team/rana.jpg"),
      title: "RudrapratapSing Ahirrao",
      text: "Working President",
    },
    {
      image: require("../../../Assets/Team/chiku.jpg"),
      title: "Khushal Wagh",
      text: "Research Analyst",
    },
    {
      image: require("../../../Assets/Team/om.jpg"),
      title: "Rohit Aghav",
      text: "District Manager (Dhule)",
    },
    {
      image: require("../../../Assets/Team/jayu2.jpg"),
      title: "Jayashree Kuwar",
      text: "Social Media Analyst",
    },
    {
      image: require("../../../Assets/Team/kalyani2.jpg"),
      title: "Kalyani Patil",
      text: "Social Media Analyst",
    },
    {
      image: require("../../../Assets/Team/akshayblacky.jpg"),
      title: "Akshay Patil",
      text: "Social Media Manager",
    },
    {
      image: require("../../../Assets/Team/amol.jpg"),
      title: "Amol Patil",
      text: "Legal Advisor",
    },
    {
      image: require("../../../Assets/Team/div.jpg"),
      title: "Divesh Sonawane",
      text: "Field Officer",
    },
    {
      image: require("../../../Assets/Team/bhupesh.jpg"),
      title: "Bhupesh Patil",
      text: "Field Officer",
    },
    {
      image: require("../../../Assets/Team/Himanshu.jpg"),
      title: "Himanshu Patil",
      text: "Field Officer",
    },
    {
      image: require("../../../Assets/Team/tejaspadvi.jpg"),
      title: "Tejas Padvi",
      text: "Field Officer",
    },
    {
      image: require("../../../Assets/Team/sahil.jpg"),
      title: "Sahil Nagarale",
      text: "Digital Creator",
    },
    {
      image: require("../../../Assets/Team/akshaypatil.jpg"),
      title: "Akshay Patil",
      text: "Field Officer",
    },
    {
      image: require("../../../Assets/Team/parth.jpg"),
      title: "Parth Patil",
      text: "Field Officer",
    },
    {
      image: require("../../../Assets/Team/Tejaswini2.jpg"),
      title: "Tejaswini Kotkar",
      text: "Field Officer",
    },
    {
      image: require("../../../Assets/Team/Vaishali.jpg"),
      title: "Vaishali Shrirao",
      text: "Digital Creator (YouTube)",
    },
    {
      image: require("../../../Assets/Team/gym.jpg"),
      title: "Akshay Patil",
      text: "Field Officer",
    },
    {
      image: require("../../../Assets/Team/Mane.jpg"),
      title: "Akshay Mane",
      text: "Field Officer",
    },
  ];
  
  export default teamData;
  